module.exports = __webpack_public_path__ + "img/img08.0d734132.jpg";